import { changeLocale } from '@formkit/vue'

export default defineNuxtPlugin((app) => {
  const i18n = app.$i18n
  changeLocale(i18n.locale.value)
})
